/* eslint-env jest */
import backgroundsPricelistId from './backgroundsPricelistId';

describe('backgroundsPricelistId -- whose background set a gift offers', () => {
  const gift = { id: 623 };

  it('follows the pricelist being browsed when the URL names one', () => {
    expect(backgroundsPricelistId({ pid: 655, orderPackage: { packageId: 623 }, giftPricelist: gift })).toBe(655);
  });

  it('falls back to the package the gift is attached to (a senior order)', () => {
    expect(backgroundsPricelistId({ orderPackage: { packageId: 745 }, giftPricelist: gift })).toBe(745);
  });

  it('bottoms out at the school gift pricelist', () => {
    expect(backgroundsPricelistId({ giftPricelist: gift })).toBe(623);
    expect(backgroundsPricelistId({ pid: undefined, orderPackage: {}, giftPricelist: gift })).toBe(623);
  });

  it('answers null, not undefined, when nothing is known yet (hooks stay disabled)', () => {
    expect(backgroundsPricelistId()).toBeNull();
    expect(backgroundsPricelistId({ orderPackage: null, giftPricelist: null })).toBeNull();
  });
});
